module.exports = __webpack_public_path__ + "img/projects2-icon.09bf661b.png";